import React from 'react';
import { useTranslation } from 'react-i18next';
import { typeFilterButtons } from 'types/content';
import FilterButtons from 'components/FilterButtons';
function ContentTypeFilter() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(FilterButtons, {
    label: t('property_type_colon'),
    queryParam: "type",
    options: typeFilterButtons,
    defaultOption: "all"
  });
}
export default ContentTypeFilter;